import { Checkbox } from "@mui/material"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { editVerify } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function PreServiceCodingReview() {
    const dispatch = useAppDispatch();
    const verify = useAppSelector((state) => state.verification.verification);
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
                color='primary'
                value={verify.preServiceCodingReviewComplete}
                checked={verify.preServiceCodingReviewComplete}
                onChange={(e) => dispatch(editVerify(new ReduxUpdate('preServiceCodingReviewComplete', e.target.checked)))}
            />
            <span style={{ userSelect: 'none', marginLeft: 4 }}>
                Pre-service coding review completed.
            </span>
        </div>
    );
}

// This component is now used in the Management tab only.

export { PreServiceCodingReview }